import { useEffect } from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { Card, CardContent } from '@pfida-finance/ui/components';
import { eventBus } from '@/libs/eventBus';
import { useGetSavingsPoints, type SavingsPointsData } from '../hooks/useGetSavingsPoints';
import { getSavingsPointsWidgetState } from '../utils/getSavingsPointsWidgetState';
import { FinanceFormNeeded } from './states/financeFormNeeded';
import { BuildingPoints } from './states/buildingPoints';
import { BelowMinimumInvestment } from './states/belowMinimumInvestment';
import { BuildingPointsDownPaymentReady } from './states/buildingPointsDownPaymentReady';
import { FullyDivested } from './states/fullyDivested';
import { DownPaymentNeeded } from './states/downPaymentNeeded';
import { ReadyInQueue } from './states/readyInQueue';
import { NearContact } from './states/nearContact';
import { DipInProgress } from './states/dipInProgress';
import { DipExpired } from './states/dipExpired';
import { ConsortiumInvestor } from './states/consortiumInvestor';

export function SavingsPointsWidget() {
  const isEnabled = useFeatureValue('enable-savings-widget', false);
  const { data, isLoading } = useGetSavingsPoints();

  useEffect(() => {
    if (!isLoading) {
      eventBus.emit('mife:savings-points-loaded', {});
    }
  }, [isLoading]);

  if (!isEnabled || isLoading || !data || !('username' in data)) return null;

  const savingsData = data as SavingsPointsData;

  if (!savingsData.first_invested_date) return null;

  const state = getSavingsPointsWidgetState(savingsData);

  return (
    <Card className="mt-6">
      <CardContent className="pt-6">
        {state === '1' && <FinanceFormNeeded data={savingsData} />}
        {state === '2' && <BuildingPoints data={savingsData} />}
        {state === '2a' && <BelowMinimumInvestment data={savingsData} />}
        {state === '2c' && <BuildingPointsDownPaymentReady data={savingsData} />}
        {state === '2f' && <FullyDivested data={savingsData} />}
        {state === '3' && <DownPaymentNeeded data={savingsData} />}
        {state === '3a' && <ConsortiumInvestor data={savingsData} />}
        {state === '4' && <ReadyInQueue data={savingsData} />}
        {state === '5' && <NearContact data={savingsData} />}
        {state === '6a' && <DipInProgress data={savingsData} />}
        {state === '6b' && <DipExpired data={savingsData} />}
      </CardContent>
    </Card>
  );
}
